import React from "react";
import { DashboardView } from "../dashboard/views/DashboardView";
import styles from "./settings.css";
import { SettingsEdit } from "./settingsEdit";
import { SettingsNavigation } from "./settingsNavigation";

export interface Props {
  view: DashboardView;
}

export const SettingsContainer = ({ view }: Props) => {
  return (
    <div className={styles["settings-container"]}>
      <SettingsNavigation view={view} />
      <SettingsEdit view={view} />
    </div>
  );
};
